import React from 'react'
import { sharedData } from '../../../models/shared_data'

import { SelectComponent } from '../../shared/select/select.component'
import { CheckBoxComponent } from '../../shared/checkbox/checkbox.component'

export class AdditionalFields extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      order: props.ord
    }

    this.isError = this.isError.bind(this)
    this.updateField = this.updateField.bind(this)
    this.updateSelectField = this.updateSelectField.bind(this)
  }

  isError(ind) {
    const l = this.props.errors.order['base']
    if(l && l.includes("additional_"+ind))
      return ' error '
    return ''
  }

  updateField(ind, e) {
    e.preventDefault()
    let v = e.target.value
    this.setState((ps)=> {
      ps.order.additional_fields_collected[ind]['value'] = v
      return ps
    })
  }

  updateSelectField(ind, e) {
    // e.preventDefault()
    let v = e.target.value
    this.setState((ps)=> {
      ps.order.additional_fields_collected[ind]['value'] = v
      return ps
    })
  }


  render() {
    const cl = sharedData.data.client
    const ord = this.state.order
    let values = []

    return (
      <div>
        { ord.additional_fields_collected.map((af, ind)=> (
            <div key={ind}>
              { af.type == 'string' &&
                <div className="input-white">
                  <input
                    className={"input-white__text" + this.isError(ind)}
                    placeholder={af.title} type="text"
                    name="title_{ind}"
                    value={af.value}
                    onChange={(e)=> {this.updateField(ind, e)}}
                  />
                </div>
              }

              { af.type == 'text' &&
                <div className="mt-15">
                  <textarea
                    className={"input-white__text" + this.isError(ind)}
                    placeholder={ af.title } type="text"
                    name="title_{ind}"
                    value={af.value}
                    onChange={(e)=> {this.updateField(ind, e)}}
                  ></textarea>
                </div>
              }

              { af.type == 'select' &&
                <div className="mt-15">
                  <SelectComponent
                    opts={af.values.map(x=>{return {title: x, id: x}})}
                    value={af.value}
                    onChange={ (e)=> { this.updateSelectField(ind, e) } }
                  />
                </div>
              }

              { af.type == 'boolean' &&
                <CheckBoxComponent
                  title={af.title}
                  value={af.value}
                  onChange={(v)=> {this.updateSelectField(ind, {target: {value: v}})}}
                  cl="mr-10"
                />
              }
            </div>

          )
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/additional_fields.component.jsx